// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2xbsH","containerItemsCenter":"Skeleton_containerItemsCenter__DYn6b"};